var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.1666,
    cy: 17,
    r: 17,
    fill: "#F5F6F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4999 9.5H18.8333C19.7537 9.5 20.4999 10.2462 20.4999 11.1667V12H23.8333C24.7537 12 25.4999 12.7462 25.4999 13.6667V22.8333C25.4999 23.7538 24.7537 24.5 23.8333 24.5H10.4999C9.57944 24.5 8.83325 23.7538 8.83325 22.8333V13.6667C8.83325 12.7462 9.57944 12 10.4999 12H13.8333V11.1667C13.8333 10.2462 14.5794 9.5 15.4999 9.5ZM10.4999 13.6667H13.8333H20.4999H23.8333V17.8333H17.9999H16.3333H10.4999V13.6667ZM10.4999 22.8333V19.5H16.3333V20.3333H17.9999V19.5H23.8333V22.8333H10.4999ZM18.8333 11.1667V12H15.4999V11.1667H18.8333Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLob);
export default __webpack_public_path__ + "static/media/lob.1f45d30e.svg";
export { ForwardRef as ReactComponent };